import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  background-color: #ffffff;

  @media (max-width: 770px) {
    flex-direction: column;
    height: 100%;
    min-height: 100%;
    overflow-y: auto;
    padding: 0;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;

  @media (max-width: 770px) {
    width: 100%;
    height: auto;
    min-height: 100%;
    background-color: #ffffff;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 4px 20px;
  background-color: white;

  @media (max-width: 770px) {
    padding: 0 16px 8px 16px;
  }
`;

export const PageContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
`;

export const MainContent = styled.div`
  padding: 4px 32px 12px 80px;
  height: calc(100vh - 110px);
  overflow-y: hidden;

  /* Tela pequena (ex: 14" ou menor) e mobile - scroll vertical à direita */
  @media (max-width: 1366px) {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  @media (max-width: 770px) {
    padding: 8px 16px 100px 16px;
    height: calc(100vh - 140px);
    max-height: calc(100vh - 140px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

export const TopSection = styled.div`
  margin-bottom: 12px;

  @media (max-width: 770px) {
    margin-bottom: 16px;
  }
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 12px;
  width: 95%;

  @media (max-width: 770px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 16px;
  }
`;

export const OrderCtaButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  background: linear-gradient(135deg, #000fff 0%, #0044ff 100%);
  color: #fff !important;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none !important;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(0, 15, 255, 0.4);
  transition: all 0.3s ease;
  white-space: nowrap;
  text-align: center;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 15, 255, 0.5);
  }

  @media (max-width: 770px) {
    width: 100%;
    padding: 12px 20px;
    white-space: normal;
  }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;
